export default {
    name: 'clients',
    component: () => import(/* webpackChunkName: "clients-layout" */ '@/modules/clients/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.clients.index',
            component: () => import(/* webpackChunkName: "clients-index" */ '@/modules/clients/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.clients.create',
            component: () => import(/* webpackChunkName: "clients-create" */ '@/modules/clients/views/Create'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.clients.edit',
            component: () => import(/* webpackChunkName: "clients-edit" */ '@/modules/clients/views/Edit'),
        },
    ]
}